import React from 'react';
import FormField from './FormField';

const FormTab = ({ tabConfig, formikProps }) => {
  const values = formikProps?.values || {};
  const errors = formikProps?.errors || {};
  const touched = formikProps?.touched || {};
  const setFieldValue = formikProps?.setFieldValue;

  return (
    <div className="form-tab">
      <h2 className="tab-title">{tabConfig.title}</h2>

      <div className="fields-container">
        {tabConfig.fields.map((field) => {
          if (field.dependsOn) {
            const dependsOnValue = values[field.dependsOn.field];
            if (field.dependsOn.includeIn === "multiselect") {
              if (!Array.isArray(dependsOnValue) || !dependsOnValue.includes(field.dependsOn.value)) {
                return null;
              }
            } else {
              if (dependsOnValue !== field.dependsOn.value) {
                return null;
              }
            }
          }

          return (
            <FormField
              key={field.name}
              field={field}
              value={values[field.name] || ""}
              setFieldValue={setFieldValue}
              error={errors[field.name]}
              touched={touched[field.name]}
            />
          );
        })}
      </div>
    </div>
  );
};

export default FormTab;
